import * as _ from 'underscore';
import React from 'react';

import Button from 'material-ui/Button';
import MDTag from '../MegaDrop/MegaDropTag';
import ExerciseVideoThumbnail from '../Exercise/ExerciseVideoThumbnail';

import { getBlockTitle } from '../../../../lib/designerUtils';
import Console from '../../../../lib/debug';

export default class PreviewExercise extends React.Component {
    render() {
        Console.render('designer.PreviewExercise');
        let { exercise, disableEdit } = this.props;
        let video = null;
        let tags = <em>No tags available</em>;
        let description = <em>No data available</em>;
        let editButton = null;
        if (!disableEdit && exercise.can_edit) {
            editButton = (
                <div className="Preview-footer">
                    <Button primary={false} onClick={this.props.onEdit}>
                        Edit
                    </Button>
                </div>
            );
        }
        if (exercise.video) {
            video = (
                <div className="video">
                    <i className="mdi mdi-video" />
                    <span>{exercise.video_url}</span>
                </div>
            );
        }
        if (exercise.tags && exercise.tags.length) {
            tags = exercise.tags.map(t => <MDTag key={`${t.id}`} tag={t} />);
        }
        if (exercise.points_of_performance || exercise.instruction) {
            description = (
                <pre>
                    {exercise.points_of_performance || exercise.instruction}
                </pre>
            );
        }
        let exercises = null;
        let exerciseWrapper = null;
        if (
            exercise.eType === 'wc' &&
            exercise.plain_text === 1 &&
            exercise.exercises.length
        ) {
            exercises = exercise.exercises.map((ex, i) => (
                <ExerciseVideoThumbnail
                    key={`video-${ex.id}`}
                    exercise={ex}
                    position={i}
                    hideDelete={true}
                />
            ));
            exerciseWrapper = (
                <div className="exercises">
                    <label>Exercises</label>
                    {exercises}
                </div>
            );
        } else if (
            exercise.eType === 'wc' &&
            exercise.plain_text !== 1 &&
            exercise.exercises.length
        ) {
            let i = 0;
            exercises = exercise.exercises.map(ex => {
                let _ex = null;
                let foundExercise = _.find(this.props.exerciseRef, exRef => {
                    if (parseInt(exRef.id) === parseInt(ex.exercise_id))
                        return true;
                });
                if (foundExercise) {
                    _ex = (
                        <li key={`ex-${foundExercise.id}`}>
                            <span className="exercise-subtitle">
                                {getBlockTitle(i)}
                            </span>
                            {foundExercise.title}
                        </li>
                    );
                }
                i++;
                return _ex;
            });
            exerciseWrapper = (
                <div className="exercises">
                    <label>Exercises</label>
                    {exercises}
                </div>
            );
        }
        let usedTimes = exercise.use_count ? (
            <p className="used-times">Used: {exercise.use_count} times</p>
        ) : null;
        return (
            <div className="Preview-content">
                <div className="Preview-header">
                    <div className="Preview-header-title">
                        <img
                            className="icon"
                            src={exercise.icon}
                            alt={exercise.stitle}
                        />
                        <h2 className="title">{exercise.title}</h2>
                    </div>
                    {usedTimes}
                </div>
                <div className="Preview-body">
                    {video}
                    <div className="tags">
                        <i className="mdi mdi-tag" />
                        <span>{tags}</span>
                    </div>
                    <div className="description">
                        <i className="mdi mdi-format-list-bulleted" />
                        {description}
                    </div>
                    <div>{exerciseWrapper}</div>
                </div>
                {editButton}
            </div>
        );
    }
}
